import axios from "axios";

export default function createRole({ name }) {
  return new Promise((resolve, reject) =>
    axios
      .post(`/account/system-admin/api/v1/admin-role`, {
        name,
      })
      .then((response) => resolve(response.data))
      .catch((error) => reject(error.message))
  );
}
